module.exports = __webpack_public_path__ + "img/contact_banner_mobile.a854ca11.jpg";